
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/buying-guides/[[...path]]",
      function () {
        return require("private-next-pages/buying-guides/[[...path]].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/buying-guides/[[...path]]"])
      });
    }
  